import ArtifactGroupType from "../base/ArtifactGroupType";


const IlkhanicTables = {
  id: '154',
  name: 'Ilkhanic Tables',
  groupIcon: 'PathsOfIncense',
  type: ArtifactGroupType.PATH_OF_INCENSE,
  icon: 'IlkhanicTables',
  power: 25,
  gameId: 'IlkhanicTables'
};

export default IlkhanicTables;
